import React from 'react';
import { MUTED, DANGER } from './tokens';
import { useSoft } from './SurfaceStyleContext';

/** 10px/700/0.1em muted field label with an optional red asterisk. */
export default function FieldLabel({ children, required = false, htmlFor, className = '', small = false }) {
  const soft = useSoft();
  return (
    <label htmlFor={htmlFor} className={`block font-mono font-bold uppercase ${className}`} style={{ fontSize: small ? 9 : 10, letterSpacing: soft ? '0.16em' : '0.1em', color: soft ? '#000' : MUTED }}>
      {children}{required && <span style={{ color: DANGER }}> *</span>}
    </label>
  );
}
